import React, { Children, Component, ReactElement } from 'react';

import { RequestDataCollectorAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, element, eventListener, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { SubmitEvent } from '@philips-emr/tws-core/lib/component/types';
import { isFunction, propagateProps } from '@philips-emr/tws-utils';

interface RequestDataCollectorProps {
  children: ReactElement | ReactElement[];
  onNextPage: Function;
  uuid: string;
}

@AwesomeComponent({ type: ComponentType.BEHAVIOR, api: RequestDataCollectorAPI })
class RequestDataCollector extends Component<RequestDataCollectorProps> {

  static propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    onNextPage: eventListener,
    uuid: string,
  };

  onSubmit = ({ record }: SubmitEvent): void => {
    const { onNextPage } = this.props;

    isFunction(onNextPage) && onNextPage({ params: record, mergeParams: true });
  };

  render(): ReactElement | ReactElement[] | null {
    const { children, uuid } = this.props;

    const Container = ContainerProvider.provide(this);

    if (!Container) {
      return null;
    }

    if (Children.count(children) === 0) {
      return <Container className="u-expand" uuid={uuid} />;
    }

    return (
      propagateProps(children, {
        onSubmit: this.onSubmit,
        onCancel: this.onSubmit,
      })
    );
  }
}

export default RequestDataCollector;
